import React, { useEffect } from 'react';

import Logo from '../assets/logo-sarovar.svg';
import { useNavigate } from 'react-router-dom';
const SplashScreen = () => {
    const navigate = useNavigate();
    // const { hotelDetails } = useHotel();

    useEffect(() => {
        let id = setTimeout(() => {
            navigate('/', { replace: true });
        }, 3000);
        return () => clearTimeout(id);
    }, []);
    return (
        <div className='bg-img min-h-dvh flex justify-center items-center'>
            <div className='logo-splash'>
                    <img
                        src={Logo}
                        alt='logo'
                        className='max-w-60 md:max-w-60'
                        onClick={() => navigate('/', { replace: true })}
                    />
            </div>
        </div>
    );
};

export default SplashScreen;
